






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'
import {InputPontaSlaSchema} from '@/schema/resource/PontaSla/InputPontaSlaSchema'

@Component
export default class PersistPontaSlaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputPontaSlaSchema()
  pontaSla = new PontaSla()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.pontaSla.getPontaSla(id)
    }

    $.await.done('getPontaSla')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.pontaSla.persistPontaSla()
    await Helper.successAndPush('system.success.persist', '/ponta-sla/list')
  }
}
